export default __webpack_public_path__ + "media/images/theme/wordmark_light-115296885a901fbca6705d9ebaa743b1.png";